import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Gallery.css'


function Gallery() {

  let navigate = useNavigate()

  return (
    <div className='gallery'>
      <div className='gallery__container'>
        <h1 className='gallery_header'>Gallery</h1>
        <div className="gallery_img_container">
          <div className="gallery_box gallery_box-lh" data-aos="zoom-in" data-aos-duration="1500">
            <img src="https://res.cloudinary.com/mec-cs-store/image/upload/v1659087483/gallery/jbckyfflj1csztgzuo92.jpg" alt="Gallery" />
          </div>
          <div className="gallery_box" data-aos="zoom-in" data-aos-duration="1500">
            <img src="https://res.cloudinary.com/mec-cs-store/image/upload/v1659453369/gallery/Screenshot_2022-08-02_185731_gvejhs.png" alt="Gallery" />
          </div>
          <div className="gallery_box gallery_box-lw" data-aos="zoom-in" data-aos-duration="1500">
            <img src="https://res.cloudinary.com/mec-cs-store/image/upload/v1659453372/gallery/WhatsApp_Image_2022-07-29_at_5.45.56_PM_wyt53e.jpg" alt="Gallery" />
          </div>
          <div className="gallery_box gallery_box-lw" data-aos="zoom-in" data-aos-duration="1500">
            <img src="https://res.cloudinary.com/mec-cs-store/image/upload/v1659087544/gallery/d9o4fqacixbe3xec19gq.jpg" alt="Gallery" />
          </div>
          <div className="gallery_box gallery_box-lh gallery_box-lwm" data-aos="zoom-in" data-aos-duration="1500">
            <img src="https://res.cloudinary.com/mec-cs-store/image/upload/v1659087465/gallery/uk0lhzj8fmccgb5obmpg.jpg" alt="Gallery" />
          </div>
          <div className="gallery_box gallery_box-lw" data-aos="zoom-in" data-aos-duration="1500">
            <img src="https://res.cloudinary.com/mec-cs-store/image/upload/v1658294326/gallery/vnjplprumnyeczvph0k3.jpg" alt="Gallery" />
          </div>
          <div className="gallery_box" data-aos="zoom-in" data-aos-duration="1500">
            <img src="https://res.cloudinary.com/mec-cs-store/image/upload/v1658294351/gallery/wyuuxi9kkxgn3ptju8d4.jpg" alt="Gallery" />
          </div>
        </div>
        <div className="btn" onClick={() => navigate('/gallery')}>View All</div>
      </div>
    </div>
  )
}

export default Gallery